<template>

    <div class="container">
        <!--created method - just evaluating the parameters-->

        <StepGuide :stepCount="0"></StepGuide>

        <div class="body padding textAlignCenter">

        <!--<h1 class="paddingTopLarge teal">Analysing your artwork</h1>-->
            <span class="centerContainer rifat" v-loading="true"
                 element-loading-text="Analysing your artwork"
                  element-loading-spinner="el-icon-loading"
                 element-loading-background="rgba(0, 0, 0, 0.8)">
            </span>

            <!--<div v-loading.fullscreen.lock="true">-->

            <!--</div>-->

        </div>
    </div>

</template>

<script>

    // import Success from '@/components/Success.vue';
    // import Failed from '@/components/Failed.vue';
    import Axios from 'axios';
    import Router from '../router';
    import StepGuide from '@/components/StepGuide.vue';

    export default {
        name: "start",
        components: {
            StepGuide
        },
        data() {
            return {
                failed: false,
                searchParams: {},
                queryParamsHelper: [
                    'propertyName',
                    'branchCode',
                    'filename',
                    'reference',
                    'source',
                    'token'
                ],
                printJob: {},
                error: false
            }
        },
        created() {

            // console.log(this.$route.query)

            this.searchParams = this.$route.query

            console.log(this.searchParams)
            console.log(typeof this.searchParams)
            // this.searchParams = new URLSearchParams(window.location.search);

            // console.log(this.searchParams.entries()) // iterator


            // real parameters
            // http://localhost:8080/?propertyName=rifat&branchCode=rifat&filename="https://media2.jupix.co.uk/v3/clients/5/properties/395696/MED_395696_240845.pdf"&reference=rifat&source=rifat&token=rifat
            // http://localhost:8080/?propertyName=rifat&branchCode=rifat&filename="https://media2.jupix.co.uk/v3/clients/5/properties/397613/MED_397613_242403.pdf"&reference=rifat&source=rifat&token=rifat

            // force error
            // http://localhost:8080/?propertyName=rifat&branchCode=rifat&filename="https://media2.jupix.co.uk/v3/clients/5/properties/397613/MED_397613_242403.pdf"&reference=rifat&source=rifat&token=


            for (let i = 0; this.queryParamsHelper.length > i; i++) {

                const param = this.queryParamsHelper[i]
                const queryParam = this.searchParams[param]
                // console.log(this.searchParams[param])
                window.sessionStorage.setItem('_' + param, queryParam);

                // console.log(queryParam)


                if (queryParam === null) {
                    this.error = true;

                } else if (queryParam === '') { // todo add or statements null, undefined
                    this.error = true;
                }
            }

            if (this.error === true) {
                Router.push({
                    name: 'error',
                    params: {
                        errorType: 'incomplete'
                    }
                });
            } else {
                console.log('starting the wizard progress')

                const url = `${process.env.VUE_APP_BACKENDHOST}/api/v1/pdfupload/orders/`
                console.log(url)
                // const uri = '"https://media2.jupix.co.uk/v3/clients/5/properties/395696/MED_395696_240845.pdf"'

                // const uri = window.sessionStorage.getItem('_filename')

                const connectionResults = {
                    "fileUri": window.sessionStorage.getItem('_filename'),
                    "branchId": window.sessionStorage.getItem('_branchCode'),
                    "customerRef": window.sessionStorage.getItem('_propertyName'),
                    "sourcePartner": window.sessionStorage.getItem('_source').toUpperCase(),
                    "partnerRef": window.sessionStorage.getItem('_reference'),
                }

                console.log(url)
                console.log(connectionResults)

                console.log('before post')

                Axios.post(url, connectionResults, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + window.sessionStorage.getItem('_token')
                    }
                })
                    .then(response => {
                        console.log(response)
                        this.printJob = response.data
                        window.sessionStorage.setItem('_printJob', JSON.stringify(this.printJob));


                        if (this.printJob.imageUrlThumb === null) {
                            Router.push({
                                name: 'error',
                                params: {
                                    printJob: this.printJob,
                                    errorType: 'nopdf',
                                    issue: 'laminations'
                                }
                            });
                        } else {
                            Router.push({
                                name: 'wizardStart',
                                params: {
                                    printJob: this.printJob
                                }
                            });
                        }

                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            console.log('rifat caught error')
                            Router.push({
                                name: 'error',
                                params: {
                                    printJob: this.printJob,
                                    errorType: 'nopdf',
                                    issue: 'laminations'
                                }
                            });
                        } else if (error.response.status === 403) {
                            console.log('rifat caught error')
                            Router.push({
                                name: 'error',
                                params: {
                                    errorType: 'onhold'
                                }
                            });
                        }
                    })
            }
        },
        methods: {}
    };
</script>